module.exports = __webpack_public_path__ + "h5/img/dpj001.7d2d31a2.gif";